import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';

import counterpart from 'counterpart';

import globalLogoImg from 'Assets/img/global-payments-logo.png';
import disputesLogo from 'Assets/img/disputes_logo.png';
import sadIconImg from 'Assets/img/icon-sad-purple.png';
import * as authActions from '../../../app/src/actions/authActions';


import { getAuthenticatedUser } from '../../../app/src/api/authApi';

import Button from 'Components/Button';
import { retrieveFirstLetter } from 'Utils/userUtils';
import './UserInactive.scss';
import UserAvatarIcon from '../icons/BIDashboard/UserAvatarIcon/UserAvatarIcon';
// This component will be used for below case :  
// 1 -  Inactive User 
export class UserInactive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuClicked: false,
      firstName: null,
      lastName: null,
      roleName: null
    };
 
    this.attachBindings();
  }
  translations = {
    seriousError: 'We are sorry, Something went wrong.',
    pleaseCall: ' There is a problem with your credentials. Please contact customer service for help. We apologize for any inconvenience.',
    logout: 'Logout'
  };


  componentDidMount() {
    document.addEventListener('mousedown', this.closeMenu);
    getAuthenticatedUser(sessionStorage.getItem("__gp_auth_token__"),false)
      .then((userResponse) => {
        this.setState({
          firstName: userResponse.data.firstName,
          lastName: userResponse.data.lastName,
          roleName: userResponse.data.role.name 
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.closeMenu);
  }

  attachBindings() {
    this.closeMenu = this.closeMenu.bind(this);
    this.logout = this.logout.bind(this);
    this.openMenu = this.openMenu.bind(this);
  }

  openMenu() {
    this.setState({ menuClicked: !this.state.menuClicked });
  }

  closeMenu(event) {
    if (
      (this.header && !this.header.contains(event.target))

    ) {
      this.setState(
        {
          menuClicked: false,
        },

      );
    }
  }


  logout() {
    let url;
    this.setState({ menuClicked: false });
    //this.props.logout(url);
    this.props.history.push('/logout');
  }

  initials() {
    let auth = JSON.parse(sessionStorage.getItem("state")).auth;
    const firstName = retrieveFirstLetter(
      this.state.firstName
    );
    const lastName = retrieveFirstLetter(
      this.state.lastName
    );
    const userName = `${firstName}${lastName}`;
    return userName;
  }

  render() {

    return (

      <div className="inactive-user-backgroud">
        <div className="inactive-user-site-header-container" >
          <header
            className="global-actions"
            onBlur={this.closeMenu}
            role="button"
            tabIndex={0}
          >
            <div className="logo-branding">
              <div className="inactive-user-logo-wrapper">
                <img
                  src={globalLogoImg}
                  alt="Global Payments"
                  className="gp-logo"
                />
              </div>
            </div>

            <div
              ref={(ref) => { this.header = ref; }}

            >
              {this.state.menuClicked &&
                <div className="inactive-user-submenu">
                  <div className="profile-buttons">
                    <Button extraClass="profile-button">
                      <span className="inactive-user-profile-avatar">{this.initials()}</span>
                      <span className="inactive-user-profile-details">
                        <span className="inactive-user-profile-name ">{this.state.firstName} {this.state.lastName}</span>
                        <span className="inactive-user-profile-role">{this.state.roleName}</span>
                      </span>
                    </Button>
                  </div>
                  <Button extraClass="inactive-user-logout-button" action={this.logout}>
                       {this.translations.logout}
                  </Button>

                </div>
              }
              {this.userLink}
            </div>
          </header>
        </div>


        <nav id="primary-nav" className="inactive-user-primary-nav">
          <header className="inactive-user-primary-nav__header">
            <span className="inactive-user-primary-nav__header-title">
            <img
                  src={disputesLogo}
                  alt="Global Payments"
                  className="disputes-logo"
                />
             
            </span>
          </header>
        </nav>


        <div className="inactive-user-global-filter-bar" />

        <div className="inactive-message">
          <img src={sadIconImg} className="icon-sad" />
          <div className="sorry-message">
            {this.translations.seriousError}
          </div>

          <div className="please-call">
            <span ></span>
            {this.translations.pleaseCall}
            <span className="please-call__text-style-1" ></span>

          </div>
        </div>
      </div>


    );
  }

  get userLink() {
    const firstName = retrieveFirstLetter(
      this.state.firstName,
    );
    const lastName = retrieveFirstLetter(
      this.state.lastName,
    );
    const userName = `${firstName} ${lastName}`;
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={this.openMenu}
        className="inactive-user-menu"
      >
         <UserAvatarIcon userName={userName} 
          isMenuExpand={this.state.menuClicked}
         />
      </div>
    );
  }
}

UserInactive.propTypes = {
  auth: PropTypes.object.isRequired,
  logout: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default withRouter(connect(mapStateToProps)(UserInactive));
